import { Text } from 'localmed-core';
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { DiButton } from '../../../../shared/components/DiComponents';
import { DiNotFoundPage } from '../../../../shared/components/DiLayout';

interface IProps {
  refetch: () => void;
}

export default function SchedulingErrorPage({ refetch }: IProps) {
  return (
    <DiNotFoundPage>
      <Fragment>
        <Text>
          <FormattedMessage
            id="scheduling.SchedulingPage.PageNotFoundMessage"
            defaultMessage="We’re sorry, something unexpected happened. We’ve been notified about this issue. Please try again in a few minutes."
          />
        </Text>
        <DiButton onClick={() => refetch()} size="xl" mt="xl">
          Retry
        </DiButton>
      </Fragment>
    </DiNotFoundPage>
  );
}
